/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type FromEventSourceNotification = {
    type: FromEventSourceNotification.type;
    eventId: number;
};
export namespace FromEventSourceNotification {
    export enum type {
        FROM_EVENT = 'from_event',
    }
}

